




import { Component, Mixins } from 'vue-property-decorator';
import Users from '@/components/users/Users.vue';
import Mixin from '@/mixins/base';

@Component({
  mixins: [Mixin],
  components: {
    'app-users': Users
  }
})
export default class UsersView extends Mixins(Mixin) {

}
